export type Section = {
    nom:string;
    taille:Size;
}

export enum Size {
    S = "S",
    M = "M",
    L = "L",
  }